// extracted by mini-css-extract-plugin
module.exports = {"warnings":"Warnings_warnings__3aimC","box":"Warnings_box__1WDgm"};